module.exports = __webpack_public_path__ + "static/media/Project-Education.ced838de.svg";